import { jsx as _jsx } from "react/jsx-runtime";
import { ContentBody } from "./ContentBody";
import { useI18n } from "@/contexts/i18n";
import { TooltipInfos } from "../tooltip";
import { InfoCircleIcon } from "@gemini/icons";
export const DsaElement = () => {
    const { t } = useI18n();
    return (_jsx(TooltipInfos, { content: _jsx(ContentBody, {}), text: t("advertising.slot.dsa.sponsored"), icon: _jsx(InfoCircleIcon, { size: "sizing.16", color: "color.content.light.default", position: "relative" }) }));
};
